import { render } from "./UserRelationButton.vue?vue&type=template&id=4d0b413a&scoped=true"
import script from "./UserRelationButton.vue?vue&type=script&lang=js"
export * from "./UserRelationButton.vue?vue&type=script&lang=js"

import "./UserRelationButton.vue?vue&type=style&index=0&id=4d0b413a&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0b413a"]])

export default __exports__